export interface IBadResponseData {
    code: string|undefined;
    message: string|undefined;
    errors: Record<string, unknown>|undefined;
}

export default class BadResponseData {
    public code: string;
    public message: string;
    public errors: Record<string, unknown>;

    constructor(data: IBadResponseData) {
        this.code = data.code ?? "unknown";
        this.message = data.message ?? "Something unexpected happened.";
        this.errors = data.errors ?? {};
    }
}
